import React, {Component} from "react";
import {NaverMap, Marker} from "react-naver-maps";

class NaverMapComponent extends Component{

    render(){
        const rootStore = this.props.rootStore;
        const navermaps = window.naver.maps;
        
        return(
            <div className={"map"}>
            {
                (rootStore.viewStore.getKakaoMapLat)?    
                    <NaverMap  
                        mapDivId={'react-naver-map'} style={{ width: "100%", height: "316px" }}
                        center={{ lat: rootStore.viewStore.getKakaoMapLat, lng: rootStore.viewStore.getKakaoMapLng }}
                        //defaultZoom={17}
                        //zoomControl= {true}
                    >
                        <Marker
                            position={new navermaps.LatLng( rootStore.viewStore.getKakaoMapLat, rootStore.viewStore.getKakaoMapLng )}
                        />
                    </NaverMap>
                    :null
            }
            </div>
        )
        
    }
}

export default NaverMapComponent;